import { createFileRoute } from '@tanstack/react-router';

import { PreferencesPage } from '../../portal/preferences-page';

/**
 * `/account/preferences` — notification preferences and the consents behind them (M9.12,
 * FR-NOTIF-08, FR-CRM-04).
 *
 * Its own screen rather than a card on `/account/profile`: the contact details are one
 * `PATCH /patient/me` with one permission, and this is three routes with two others
 * (`portal.profile.update` and `portal.profile.read`, API.md §2.4). They were one card
 * only while the preferences were a single email checkbox.
 */
export const Route = createFileRoute('/account/preferences')({
  component: PreferencesPage,
});
